import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle, Clock, AlertCircle, FileText } from 'lucide-react';
import { getAnalysisById } from '../../data/centralizedData';

const AnalysisDetail = ({ analysisId, onSectionChange }) => {
  const navigate = useNavigate();
  const analysis = getAnalysisById(analysisId);

  if (!analysis) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Analysis Not Found</h2>
          <p className="text-gray-600 mb-4">The requested analysis could not be loaded.</p>
          <button
            onClick={() => navigate('/analysis')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Back to Analysis List
          </button>
        </div>
      </div>
    );
  }

  const getStatusIcon = (status) => {
    switch(status) {
      case 'completed': return CheckCircle;
      case 'in-progress': return Clock;
      case 'planned': return AlertCircle;
      default: return Clock;
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'completed': return 'bg-green-100 text-green-800 border-green-200';
      case 'in-progress': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'planned': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const StatusIcon = getStatusIcon(analysis.status);

  return (
    <div className="space-y-8">
      {/* Header with Back Button */}
      <div className="flex items-center space-x-4">
        <button
          onClick={() => navigate('/analysis')}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
        <div className="flex-1">
          <h2 className="text-3xl font-bold text-gray-900">{analysis.title}</h2>
          <div className="flex items-center space-x-3 mt-2">
            <span className={`px-3 py-1 rounded-full border text-sm flex items-center space-x-2 ${getStatusColor(analysis.status)}`}>
              <StatusIcon className="w-4 h-4" />
              <span>{analysis.status}</span>
            </span>
            <span className="text-gray-600">{analysis.category}</span>
            <span className="text-gray-500">•</span>
            <span className="text-gray-600">{analysis.date}</span>
          </div>
        </div>
      </div>

      {/* Executive Summary */}
      <div className="bg-white p-8 rounded-xl border shadow-sm">
        <h3 className="text-2xl font-semibold mb-6 flex items-center space-x-2">
          <FileText className="w-6 h-6 text-blue-600" />
          <span>Executive Summary</span>
        </h3>
        <p className="text-gray-700 text-lg leading-relaxed">{analysis.executiveSummary}</p>
      </div>
    </div>
  );
};

export default AnalysisDetail;